import React, { Component } from 'react';

import Loadable from '../ui/loading/Loadable.js';
import DistanceInput from './DistanceInput.js';
// This wraps DistanceInput, and just handles the units.  It gets the default displayUnit from the api
// And the base unit is cm

import api from '../../api/index.js';

class ManagedDistanceInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			units: false
		}
	}
	
	async refresh() {
		this.setState({units: await api.settings.get('display_units')});
	}
	
	componentDidMount() {
		this.refresh();
		// Get the thing from the api
	}
	
	render() {
		return (
			<Loadable ready={this.state.units !== false}>
				<DistanceInput 
					displayUnits={this.state.units}
					placeholder={this.props.placeholder}
					value={this.props.value}
					baseUnits="cm"
					name={this.props.name} 
					onChange={this.props.onChange}
				/>
			</Loadable>
		);
	}
}

export default ManagedDistanceInput;
